import { IconSearch } from "../../../components/icons/IconsPaciente";
import { EmptyState } from "../../../components/utils/Utils";

// Paso 2: segun el tipo elegido, muestra el buscador de medicos por nombre
// o la lista de servicios. Presentacional: recibe los datos ya calculados.
const PasoCriterio = ({
    tipo,
    termino,
    onTermino,
    medicos,
    servicios,
    onElegirMedico,
    onElegirServicio,
}) => {
    if (tipo === "nombre") {
        return (
            <div className="wizard-paso">
                <h3 className="wizard-paso__titulo">Buscá un médico por nombre</h3>
                <div className="search-bar">
                    <IconSearch />
                    <input
                        type="text"
                        placeholder="Escribí el nombre del médico..."
                        value={termino}
                        onChange={(e) => onTermino(e.target.value)}
                    />
                </div>
                {medicos.length === 0 ? (
                    <EmptyState icon={<IconSearch />} title="No hay médicos que coincidan." subtitle="Probá con otro nombre." />
                ) : (
                    <div className="wizard-lista">
                        {medicos.map((medico) => (
                            <button key={medico.id} type="button" className="wizard-lista__item" onClick={() => onElegirMedico(medico)}>
                                {medico.nombre}
                            </button>
                        ))}
                    </div>
                )}
            </div>
        );
    }

    return (
        <div className="wizard-paso">
            <h3 className="wizard-paso__titulo">Elegí un servicio</h3>
            {servicios.length === 0 ? (
                <EmptyState icon={<IconSearch />} title="No hay servicios con turnos disponibles." />
            ) : (
                <div className="wizard-lista">
                    {servicios.map((servicio) => (
                        <button key={servicio.id} type="button" className="wizard-lista__item" onClick={() => onElegirServicio(servicio)}>
                            {servicio.nombre}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

export default PasoCriterio;
